import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const UserContext = createContext();

export function UserContextProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUserInfo = async () => {
        try {
            const response = await axios.get('/api/account/info');
            setUser(response.data);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch user info:', error);
            if (error.response?.status === 401) {
                setUser(null);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUserInfo();
    }, []); // Only run on mount

    const logout = async () => {
        try {
            await axios.post('/api/account/logout');
            setUser(null);
        } catch (error) {
            console.error('Failed to logout:', error);
            // Still clear the user state even if the API call fails
            setUser(null);
        }
    };

    return (
        <UserContext.Provider value={{ user, loading, logout, fetchUserInfo }}>
            {children}
        </UserContext.Provider>
    );
}
